import { createApi } from '@/api/modules/utils'

const baseUrl = '/recharge/vip'
const api = createApi(baseUrl)

// VIP套餐相关
export const vipApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'), // 购买会员
}